import Vue from 'vue'
const url = 'ws://localhost:17211/test'

let socket = null

export default {
  connect() { // 创建连接
    return new Promise((resolve) => {
      try {
        socket = socket || new WebSocket(url)

        socket.addEventListener('open', () => {
          socket.send('0|' + new Date().getTime())
          resolve(true)
        })
  
        socket.addEventListener('close', () => {
          Vue.prototype.$message.error('证书服务无法连接，请启动证书服务。')
          socket = null
          resolve(false)
        })
  
        socket.addEventListener('error', (error) => {
          console.error('服务连接出错:', error)
          socket = null
          resolve(false)
        })
      } catch (error) {
        console.error('Websocket Error:' + error)
        socket = null
        resolve(false)
      }
    })
  },

  sendMessage(func, params = {}) { // 发送消息，每次都会先检查连接状态，如果没有连接则创建后再发送消息
    const f = (r) => {
      func(params)
      .then(res => {
        r(res)
      })
      .catch(e => {
        console.error(e)
        r(null)
      })
    }

    return new Promise((resolve) => {
      if (!socket) {
        this.connect()
        .then(res => {
          if (res) {
            f(resolve)
          }
        })
      } else {
        f(resolve)
      }
    })
  },

  getSealCount() {  // 获取usb签章数量
    const func = () => {
      return new Promise((resolve, reject) => {
        const msg = '1|GetSealCount'
        socket.send(msg)
        socket.addEventListener('message', (resp) => {
          try {
            const args = resp.data.split('|')
            if (args[1] == 'GetSealCount') {
              const json = eval('(' + args[2] + ')')
              if (json.ret == 0) {
                var count = json.count
                resolve(count)
              } else {
                reject(json.msg)
              }
            }
          } catch (error) {
            reject(error)
          }
        })
      })
    }

    return this.sendMessage(func)
  },

  getSealSN(index) { // 获取签章SN，index为usb签章的序号
    const func = () => {
      return new Promise((resolve, reject) => {
        const msg = `1|GetSealSn|{"index": ${index}}`
        socket.send(msg)
        socket.addEventListener('message', (resp) => {
          try {
            const args = resp.data.split('|')
            if (args[1] == 'GetSealSn') {
              const json = eval('(' + args[2] + ')')
              if (json.ret == 0) {
                const { sn } = json
                resolve(sn)
              } else {
                reject(json.msg)
              }
            }
          } catch (error) {
            reject(error)
          }
        })
      })
    }

    return this.sendMessage(func)
  },

  getCert(sn) { // 获取证书，需要传入SN
    const func = () => {
      return new Promise((resolve, reject) => {
        const msg = `1|GetCert|{"sn":"${sn}"}`
        socket.send(msg)
        socket.addEventListener('message', (resp) => {
          try {
            const args = resp.data.split('|')
            if (args[1] == 'GetCert') {
              const json = eval('(' + args[2] + ')')
              if (json.ret == 0) {
                const { cert } = json
                resolve(cert)
              } else {
                reject(json.msg)
              }
            }
          } catch (error) {
            reject(error)
          }
        })
      })
    }

    return this.sendMessage(func)
  },

  getSignatureResult(sn, content) { // 获取签章结果和图片，需要传入SN和签章内容
    const func = () => {
      return new Promise((resolve, reject) => {
        const msg = `1|SignAndSealForResult|{"content":"${content}","sn":"${sn}","encode":1,"attach":1,"isshow":1}`
        let sealResult = ''

        socket.send(msg)
        socket.addEventListener('message', (resp) => {
          try {
            const args = resp.data.split('|')
            if (args[1] == 'SignAndSealForResult') {
              const json = eval('(' + args[2] + ')')
              if (json.ret == 0) {
                const { result } = json
                if (result) {
                  sealResult = result
                  const verifyMsg = `1|VerifyAndShowSealWithResult|{"result":"${result}","encode":1,"content":"${content}","type":100}`
                  
                  socket.send(verifyMsg)
                }
              } else {
                console.error('verify error', json.msg)
              }
            }

            if (args[1] == 'VerifyAndShowSealWithResult') {
              const showMsg = '1|GetVerifySealPic'
              socket.send(showMsg)
            }

            if (args[1] == 'GetVerifySealPic') {
              const json = eval('(' + args[2] + ')')
              if (json.ret == 0) {
                const { verifysealpic } = json
                resolve({result: sealResult, image: verifysealpic})
              } else {
                reject(json.msg)
              }
            }
          } catch (error) {
            reject(error)
          }
        })
      })
    }

    return this.sendMessage(func)
  },



}